import { inject } from "@angular/core";
import { Actions } from "@ngrx/effects";

export class UiEffects {
    actions$: Actions = inject(Actions);

}